var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tcm-con flex flex-col" }, [
    _c("div", { staticClass: "tcm-title-con flex flex-col" }, [
      _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.row.name))]),
      _c("div", { staticClass: "sub-title-con flex flex-row align-center" }, [
        _c("span", { staticClass: "sub-title text-ellipsis" }, [
          _vm._v("国药准字：" + _vm._s(_vm.row.materielCode)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "body-con self-center" }, [
      _c("div", { staticClass: "list-con" }, [
        _c("div", { staticClass: "list-item flex flex-col w-full" }, [
          _vm._m(0),
          _c("div", { staticClass: "content" }, [
            _vm._v(" " + _vm._s(_vm.row.symContent) + " "),
          ]),
        ]),
        _c("div", { staticClass: "list-item flex flex-col w-full" }, [
          _vm._m(1),
          _c("div", { staticClass: "content" }, [
            _vm._v(" " + _vm._s(_vm.row.fdmContent) + " "),
          ]),
        ]),
        _c("div", { staticClass: "list-item flex flex-col w-full" }, [
          _vm._m(2),
          _c("div", { staticClass: "content" }, [
            _vm._v(" " + _vm._s(_vm.row.chDiagContent) + " "),
          ]),
        ]),
        _c("div", { staticClass: "list-item flex flex-col w-full" }, [
          _vm._m(3),
          _c("div", { staticClass: "content" }, [
            _vm._v(" " + _vm._s(_vm.row.chYndromeContent) + " "),
          ]),
        ]),
        _c("div", { staticClass: "list-item flex flex-col w-full" }, [
          _vm._m(4),
          _c("div", { staticClass: "content" }, [
            _vm._v(" " + _vm._s(_vm.row.chTherapyContent) + " "),
          ]),
        ]),
        _vm._m(5),
        _c("div", { staticClass: "list-item flex flex-col w-full" }, [
          _vm._m(6),
          _c("div", { staticClass: "content" }, [
            _vm._v(" " + _vm._s(_vm.row.prescriptionDescribe) + " "),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "option-con flex flex-row w-full mb-10" },
      [
        _c(
          "el-button",
          {
            staticClass: "w-full",
            attrs: { type: "primary", plain: "" },
            on: {
              click: function ($event) {
                return _vm.showDetail(_vm.row)
              },
            },
          },
          [_vm._v("详情 ")]
        ),
        _c(
          "el-button",
          {
            staticClass: "btn w-full",
            attrs: { type: "primary" },
            on: { click: _vm.handleChoose },
          },
          [_vm._v("选择")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("@/assets/tcm/Frame(23).png"), alt: "" },
      }),
      _c("span", { staticClass: "label" }, [_vm._v("主诉")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("@/assets/tcm/Frame(23).png"), alt: "" },
      }),
      _c("span", { staticClass: "label" }, [_vm._v("四诊")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("@/assets/tcm/Frame(23).png"), alt: "" },
      }),
      _c("span", { staticClass: "label" }, [_vm._v("中医病")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("@/assets/tcm/Frame(23).png"), alt: "" },
      }),
      _c("span", { staticClass: "label" }, [_vm._v("中医症")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("@/assets/tcm/Frame(23).png"), alt: "" },
      }),
      _c("span", { staticClass: "label" }, [_vm._v("治法")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "list-item flex flex-col w-full" }, [
      _c("div", { staticClass: "label-con flex flex-row align-center" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: require("@/assets/tcm/Frame(6).png"), alt: "" },
        }),
        _c("span", { staticClass: "label" }, [_vm._v("功效")]),
      ]),
      _c("div", { staticClass: "content" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("@/assets/tcm/Frame(22).png"), alt: "" },
      }),
      _c("span", { staticClass: "label" }, [_vm._v("注意事项")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }